.e6{color:var(--brand-primary);}